import { render, staticRenderFns } from "./idxSlider2.vue?vue&type=template&id=f8db30e0&"
import script from "./idxSlider2.vue?vue&type=script&lang=js&"
export * from "./idxSlider2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports